import { boot } from "quasar/wrappers";
import VueLogger from "vuejs3-logger";
import { LogLevels } from "vuejs3-logger/dist/enum/log-levels";
import { ILoggerOptions } from "vuejs3-logger/dist/interfaces/logger-options";

export default boot(({ app }) => {
  const options: ILoggerOptions = {
    isEnabled: true,
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: "|",
    showConsoleColors: true,
    logLevel: LogLevels.DEBUG,
  };

  app.use(VueLogger, options);
});
